import {
  create_project,
  update_project,
  delete_project,
  recover_project,
  query_project_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-project-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2} from "@/utils/function";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '项目编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '项目名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    code: null,
    project_type_id: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '项目名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
    {
      type: 'input',
      name: 'price',
      label: '项目单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目价格',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入项目名称' }],
    project_type_id: [{ required: true, message: '请选择项目分类' }],
    price: [{ required: true, message: '请填输入项目单价' }],
    p_type: [],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    price: null,
    p_type: [0, 10, 20],
    project_type_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '项目名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写项目名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
    {
      type: 'input',
      name: 'price',
      label: '项目价格',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目价格',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入项目名称' }],
    project_type_id: [{ required: true, message: '请选择项目分类' }],
    price: [{ required: true, message: '请填输入项目单价' }],
    p_type: [],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    price: null,
    p_type: [0, 10, 20],
    project_type_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '下单管理',
  addModalTitle: '新建下单',
  updateTitle: '修改下单',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    project_id: 'id',
  },
  delete: {
    project_id: 'id',
  },
  recover: {
    project_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    project_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    width: 50,
    dataIndex: 'index',
  },
  {
    title: '项目编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '项目名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '项目单价',
    dataIndex: 'price',
    checked: true,
  },
  {
    title: '项目分类',
    dataIndex: 'project_type__name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_project_list,
    addData: create_project,
    updateData: update_project,
    removeData: delete_project,
    recoverData: recover_project,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
